export const GET_PUBLIC_GLOBAL_ALERTS = 'GET_PUBLIC_GLOBAL_ALERTS';
export const GET_PUBLIC_GLOBAL_ALERTS_SUCCESS = 'GET_PUBLIC_GLOBAL_ALERTS_SUCCESS';
export const GET_PUBLIC_GLOBAL_ALERTS_FAILURE = 'GET_PUBLIC_GLOBAL_ALERTS_FAILURE';
